import { Component } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
    selector: 'l-list-loading',
    templateUrl: './list-loading.component.html',
    imports: [
        SpinnerComponent
    ]
})
export class ListLoadingComponent {}
